/**
 * @fileoverview gRPC-Web generated client stub for core.public.triallimits
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from "grpc-web";

import {
  GetTrialLimitRequest,
  GetTrialLimitResponse} from "./triallimits_pb";

export class TrialLimitsServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "text";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetTrialLimit = new grpcWeb.AbstractClientBase.MethodInfo(
    GetTrialLimitResponse,
    (request: GetTrialLimitRequest) => {
      return request.serializeBinary();
    },
    GetTrialLimitResponse.deserializeBinary
  );

  getTrialLimit(
    request: GetTrialLimitRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetTrialLimitResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/core.public.triallimits.TrialLimitsService/GetTrialLimit",
      request,
      metadata || {},
      this.methodInfoGetTrialLimit,
      callback);
  }

}

